import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../context/CurrencyContext';
import { CURRENCY_SYMBOLS } from '../utils/fx';

// Botón compacto con dropdown propio (no <select>) para que el estado cerrado
// muestre únicamente el símbolo de la divisa. El menú abierto sí lista
// símbolo + código para distinguir divisas que comparten símbolo (USD/MXN/COP/…).
export default function CurrencySelector() {
  const { displayCurrency, changeCurrency, supported } = useCurrency();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onAway = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onAway);
    return () => document.removeEventListener('mousedown', onAway);
  }, []);

  const select = (code) => { changeCurrency(code); setOpen(false); };
  const symbol = CURRENCY_SYMBOLS[displayCurrency] || '$';

  return (
    <div className="lang-switch" ref={ref}>
      <button
        type="button"
        className="icon-btn"
        title={t('currency.selector_label', { defaultValue: 'Divisa de visualización' })}
        aria-label={t('currency.selector_label', { defaultValue: 'Divisa de visualización' })}
        onClick={() => setOpen((v) => !v)}
        style={{ fontWeight: 700, fontSize: 14 }}
      >
        {symbol}
      </button>
      {open && (
        <div className="lang-menu">
          {supported.map((code) => (
            <button
              key={code}
              type="button"
              className={`lang-menu__item${displayCurrency === code ? ' lang-menu__item--active' : ''}`}
              onClick={() => select(code)}
            >
              <span className="lang-menu__code">{CURRENCY_SYMBOLS[code] || ''}</span>
              <span className="lang-menu__label">{code}</span>
              {displayCurrency === code && <span className="lang-menu__dot" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
